import { useState, useEffect } from 'react';

import { useVDLModalStore } from '@VDL/store/VDLModalStore';

export const useDefaultIframe = () => {
  const { defaultIframe, setDefaultIframe } = useVDLModalStore();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (defaultIframe) {
      setLoaded(false);
    }
  }, [defaultIframe]);

  return { defaultIframe, setDefaultIframe, loaded, setLoaded };
};
